import script from "./BetBoosterCardBody.vue?vue&type=script&setup=true&lang=js"
export * from "./BetBoosterCardBody.vue?vue&type=script&setup=true&lang=js"

import "./BetBoosterCardBody.vue?vue&type=style&index=0&id=1a7c4bfc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a7c4bfc"]])

export default __exports__